<div class="done-container">
  <h2>{{'done.header_h2' | translate}}</h2>
  <p class="larger">{{ 'done.header_h2_1' | translate}}</p>

  <h3>{{'done.header_h3' | translate}}</h3>
  <p class="smartlink larger" [innerHtml]="header_h3_1 | safePipe:'html'"></p>
  <p class="larger">{{ 'done.header_h3_2' | translate }}</p>
</div>
